import { Component } from "react"

/* Components */
import { InnerLayout, Tag, Pagination, Avatar } from "../../components"

/* REST API */
import { list, toggle } from "../../api/Player"

/* Helpers */
import { withRouter, utils } from "../../helpers"

/* Redux */
import { connect } from "react-redux"

/* Sweetalert */
import Swal from "sweetalert2"

/* Modal */
import Modal from "react-modal"

/* Widgets */
import { Information, Sessions, Filter } from "../../widgets/Player"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Export Excel */
import { downloadExcel as downloadXlsx } from "react-export-table-to-excel-xlsx"

/* Moment */
import moment from "moment"

/* Translate */
import { t } from "../../translates/translate"


/* Fields */
const INFORMATION = "information"
const SESSIONS = "sessions"

/* Page Players */
class Players extends Component {

    constructor(props) {
        super(props)

        const start = new Date()
        const end = new Date()
        start.setHours(0, 0, 0)
        end.setHours(23, 59, 59)

        this.state = {
            data: [],
            status: "loading",
            count: 0,
            page: 1,
            search: "",

            statistics: false,
            tab: INFORMATION,
            player: null,
            ava: null,

            operators: [...props.operators],
            start,
            end,
            selected: "today",

            downloading: false,
        }

        this._timer = null
        this._scroll = null
    }

    componentDidMount = () => {
        this.load()
    }

    componentWillUnmount = () => {
        if (this._timer) {
            clearTimeout(this._timer)
            this._timer = null
        }
    }

    /* Load action */
    load = (reload = false, page = 1) => {

        /* Fields */
        const { search, operators, start, end } = this.state

        /* Check Operators */
        if (operators && Array.isArray(operators) && operators.length === 0) {
            this.setState({ status: "permission", data: [], count: 0 })
            return
        }

        /* Reload Page */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Get Operators */
        const ids = utils.arrayID(operators)

        /* Save Page */
        this.setState({ page })

        /* Send to REST API */
        list({ page, search, ids, start, end }).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.list, count: response.data.count })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [], count: 0 })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [], count: 0 })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0 })
        })

    }

    /* Download XLSX */
    downloadXLSX = () => {

        /* Fields */
        const { search, operators, start, end } = this.state

        /* Get Operators */
        const ids = utils.arrayID(operators)

        /* Start Loading */
        this.setState({ downloading: true })

        /* Fields */
        const fitlered = this.getFilterDate()

        /* Start Loading */
        list({ page: 0, search, ids, start, end, reporting: true }).then((response) => {
            if (response.status === 200) {

                /* Fields */
                const players = response.data.list

                /* Prepare Title */
                const title = `${t("player.report")} ${fitlered.title} - ${fitlered.text}`

                /* Prepare Header */
                const header = {
                    name: t("player.reportName"),
                    players: t("player.reportCode"),
                    lastgame: t("player.reportLastGame"),
                    operator: t("player.reportOperator"),
                    currency: t("player.reportCurrency"),
                    lastLogin: t("player.reportLastSession"),
                    debit: "Debit",
                    credit: "Credit",
                    total: "TOTAL (GGR)",
                }
                const body = [{ name: title }, { name: "" }, header]

                /* Prepare Body */
                players.forEach((player) => {
                    body.push({
                        name: utils.checkValue(player.firstName, "-"),
                        players: utils.checkValue(player.player, "-"),
                        lastgame: utils.checkValue(player.game, "-"),
                        operator: utils.checkValue(player.operator, "-"),
                        currency: utils.checkValue(player.currency, "-"),
                        lastLogin: utils.checkValue(player.lastLogin, "-"),
                        debit: utils.convertor(parseFloat(Math.abs(player.debit)), "$", 0, " "),
                        credit: utils.convertor(parseFloat(Math.abs(player.credit)), "$", 0, " "),
                        total: `${player.ggr >= 0 ? "+" : "-"} ${utils.convertor(parseFloat(Math.abs(player.ggr)), "$", 0, " ")}`,
                    })
                })

                /* Call Download Excel */
                downloadXlsx({
                    fileName: `${t("player.report")} ${fitlered.title} - ${fitlered.text}`,
                    sheet: t("player.reportSheet"),
                    tablePayload: { header: [], body },
                })
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error", 2000))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error", 2000))
        }).finally(() => {
            this.setState({ downloading: false })
        })
    }

    /* Toggle */
    toggle = (item, value) => {

        /* Fields */
        const { data } = this.state

        /* Toggle Tester Modal */
        Swal.fire({
            title: t("player.changeConfirm"),
            text: t("player.changeWarning"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#03a9f4",
            reverseButtons: true,
            confirmButtonText: t("common.yes"),
            cancelButtonText: t("common.no"),
        }).then((result) => {
            if (result.isConfirmed) {

                /* Send to REST API */
                toggle({ id: item.player, value }).then((response) => {
                    if (response.status === 200) {

                        /* Get Index */
                        const index = data.findIndex((e) => e.player === item.player)

                        /* Check Index */
                        if (index > -1) {
                            data[index].isTester = value
                            this.setState({ data })
                        }

                        Swal.fire(utils.notification(t("player.statusChanged"), "success"))

                    }
                    else if (response.status === 401 || response.status === 403) {
                        Swal.fire(utils.notification(t("swal.noAccess"), "error"))
                    }
                    else if (response.status === 498) {
                        Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
                    }
                    else {
                        Swal.fire(utils.notification(t("swal.generic"), "error"))
                    }
                }).catch(() => {
                    Swal.fire(utils.notification(t("swal.generic"), "error"))
                })

            }
        })

    }


    /* Draw Time */
    _time = (time) => {

        const datetime = utils.getTime(time)

        return (
            <div className="page-table-datetime">
                <div className="page-table-time">{datetime.time}</div>
                <div className="page-table-date">{datetime.date}</div>
            </div>
        )
    }


    /* Search */
    search = (text) => {

        /* Set Search */
        this.setState({ search: text, status: "loading" }, () => {

            /* Check Timer */
            if (this._timer) {
                clearTimeout(this._timer)
                this._timer = null
            }

            /* Search After 500ms */
            this._timer = setTimeout(() => {
                this.load(true, 1)
                clearTimeout(this._timer)
                this._timer = null
            }, 500)

        })

    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status, data, count, page } = this.state

        /* Layout */
        if (status !== "ok") {
            return (
                <div className="page-table">
                    <InnerLayout status={status} reload={() => this.load(true, 1)} />
                </div>
            )
        }

        /* Empty */
        if (data.length === 0) {
            return (
                <div className="page-table">
                    <InnerLayout status="empty" />
                </div>
            )
        }

        return (
            <div className="page-table">

                <div className="player-row-header">
                    <div className="player-number-head">#</div>
                    <div className="player-user-head">{t("player.player")}</div>
                    <div className="player-game-head">{t("player.lastGame")}</div>
                    <div className="player-operator-head">{t("player.operator")}</div>
                    <div className="player-ggr-head">GGR</div>
                    <div className="player-currency-head">{t("player.currency")}</div>
                    <div className="player-date-head">{t("player.dateTime")}</div>
                    <div className="player-more-head"></div>
                </div>

                {data.map((item, index) =>
                    <div className="player-row" key={`${index}`}>

                        {/* Number */}
                        <div onClick={() => this.setState({ statistics: true, player: item.player, ava: item.ava })} className="player-number">{(page - 1) * 10 + index + 1}</div>

                        {/* Player */}
                        <div onClick={() => this.setState({ statistics: true, player: item.player, ava: item.ava })} className="player-user">
                            <Avatar uri={utils.ava(item.ava, item.isTester === 1 && "test")} size={40} />
                            <div className="player-user-text">
                                <div className="player-user-name">{item.firstName}</div>
                                <div className="player-user-code">{item.player} {parseInt(item.isTester) === 1 && <span>({t("player.isTester")})</span>}</div>
                            </div>
                        </div>

                        {/* Game */}
                        <div onClick={() => this.setState({ statistics: true, player: item.player, ava: item.ava })} className="player-game">{item.game}</div>

                        {/* Operator */}
                        <div onClick={() => this.setState({ statistics: true, player: item.player, ava: item.ava })} className="player-operator">
                            <Tag color="orange" uppercase>{utils.checkValue(item.operator, " - ")}</Tag>
                        </div>

                        {/* GGR */}
                        <div onClick={() => this.setState({ statistics: true, player: item.player, ava: item.ava })} className="player-ggr">
                            <div className="player-ggr-value">+ {utils.convertor(item.debit, "$")}</div>
                            <div className="player-ggr-value">- {utils.convertor(item.credit, "$")}</div>
                            <div className={`player-ggr-total ${parseFloat(item.ggr) > 0 && "green"} ${parseFloat(item.ggr) < 0 && "red"}`}>
                                {parseFloat(item.ggr) > 0 && "+ "}
                                {parseFloat(item.ggr) < 0 && "- "}
                                {utils.convertor(Math.abs(item.ggr), "$")}
                            </div>
                        </div>

                        {/* Currency */}
                        <div onClick={() => this.setState({ statistics: true, player: item.player, ava: item.ava })} className="player-currency">
                            <Tag color="green">{item.currency}</Tag>
                        </div>

                        {/* Date and Time */}
                        <div onClick={() => this.setState({ statistics: true, player: item.player, ava: item.ava })} className="player-date">{this._time(item.lastLogin)}</div>

                        {/* More Dropdown */}
                        <div className="player-more">

                            <div className="player-more-icon">
                                <img src="/images/dots-more.png" alt="More Dot" />
                            </div>

                            <div className="player-more-menu">

                                <div onClick={() => this.setState({ statistics: true, player: item.player, ava: item.ava })} className="player-more-menu-item">
                                    <img src="/images/player/analysis.png" alt="Remove" />
                                    <span>{t("player.viewStats")}</span>
                                </div>

                                <div className="player-more-divider" />

                                <div onClick={() => this.toggle(item, parseInt(item.isTester) === 1 ? 0 : 1)} className="player-more-menu-item">
                                    <img src="/images/player/tester.png" alt="Remove" />
                                    <span>{parseInt(item.isTester) === 0 ? t("player.setTester") : t("player.removeTester")}</span>
                                </div>

                            </div>

                        </div>
                    </div>
                )}

                {/* Pagination */}
                <Pagination size={10} page={page} total={count} onPageChange={(page) => this.load(true, page)} />

            </div>
        )
    }


    /* Draw Search */
    _search = () => {

        /* Fields */
        const { search, status } = this.state

        /* Check Status */
        if (status === "ok" || status === "loading") {
            return (
                <div className="player-search">
                    <img src="/images/player/search.png" alt="Search" />
                    <input value={search} onChange={(event) => this.search(event.target.value)} placeholder={t("player.search")} />
                </div>
            )
        }

    }

    /* Draw Filter */
    _filter = () => {

        /* Fields */
        const { status, start, end, selected, operators } = this.state
        let count = 0

        /* Operators */
        if (operators && Array.isArray(operators) && operators.length > 0) {
            count = count + 1
        }

        /* Date */
        if (start && end) {
            count = count + 1
        }

        /* Check Status */
        if (status === "ok" || status === "loading") {
            return (
                <div onClick={() => this._filterModal.open({ start, end, selected, operators })} className="player-filter">
                    <img src="/images/player/filter.png" alt="Search" />
                    <div className="player-filter-count">{count}</div>
                </div>
            )
        }

    }

    /* Draw Report */
    _report = () => {

        /* Fields */
        const { status, downloading } = this.state

        /* Check Status */
        if (status === "ok" || status === "loading") {

            /* Loading */
            if (downloading) {
                return (
                    <div className="player-report loading">
                        <LoadingOutlined />
                    </div>
                )
            }

            return <div onClick={() => this.downloadXLSX()} className="player-report">.XLSX</div>
        }
    }


    /* Scroll To Top */
    scrollToTop = () => {
        if (this._scroll) {
            this._scroll.scroll({ top: 0, behavior: "smooth" })
        }
    }

    /* Get TABS */
    _getTabs = () => [
        { key: INFORMATION, text: t("player.information"), image: "/images/player/information.png" },
        { key: SESSIONS, text: t("player.sessions"), image: "/images/player/clock.png" },
    ]

    /* Statistics Modal */
    _statistics = () => {

        /* Fields */
        const { statistics, tab, player, ava } = this.state
        const tabs = this._getTabs()

        return (
            <Modal
                isOpen={statistics}
                onRequestClose={() => this.setState({ statistics: false, player: null, ava: null })}
                className={"statistics--modal"}
                overlayClassName="statistics--overlay"
                closeTimeoutMS={200}
            >

                <div className="statistics--modal-header">
                    <h2>{t("player.statsTitle")}</h2>
                    <div onClick={() => this.setState({ statistics: false, player: null, ava: null })} className="statistics--modal-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                <div className="statistics--content" ref={(ref) => this._scroll = ref}>

                    {/* TABS */}
                    <div className="statistics--tabs">
                        {tabs.map((item, index) =>
                            <div onClick={() => this.setState({ tab: item.key })} className={`statistics--tab ${tab === item.key ? "active" : "closed"}`} key={`${index}`}>
                                <img src={`${item.image}`} alt={item.text} />
                                <div className="statistics--tab-text">{item.text}</div>
                            </div>
                        )}
                    </div>

                    {/* Content */}
                    {tab === INFORMATION && <Information player={player} ava={ava} scrollToTop={this.scrollToTop} />}
                    {tab === SESSIONS && <Sessions player={player} scrollToTop={this.scrollToTop} />}

                </div>

            </Modal>
        )
    }

    /* Get Filter Date */
    getFilterDate = () => {

        /* Fields */
        const { start, end, selected } = this.state

        const FILTERS = {
            "3hours": t("player.last3h"),
            "6hours": t("player.last6h"),
            "12hours": t("player.last12h"),
            "today": t("player.today"),
            "yesterday": t("player.yesterday"),
            "7days": t("player.last7days"),
            "14days": t("player.last14days"),
            "30days": t("player.last30days"),
            "month": t("player.thisMonth"),
            "prevmonth": t("player.prevMonth"),
            "period": t("player.filterPeriod"),
            "all": t("player.allTime"),
        }

        let title = ""
        let text = ""

        /* Default Time */
        if (selected !== "all") {
            text = moment(new Date(start)).format("DD MMM, HH:mm") + " - " + moment(new Date(end)).format("DD MMM, HH:mm")
        }

        /* Day Time */
        if (selected === "today" || selected === "yesterday") {
            title = FILTERS[`${selected}`]
            text = moment(new Date(start)).format("Do MMMM")
        }

        /* Times */
        if (selected === "3hours" || selected === "6hours" || selected === "12hours") {
            title = FILTERS[`${selected}`]
            text = `${moment(new Date(start)).format("HH:mm")} -  ${moment(new Date(end)).format("HH:mm")}`
        }

        /* Default Time */
        if (selected === "all") {
            title = t("player.allTime")
        }

        return { title, text }
    }


    render = () => {

        /* Fields */
        const fitlered = this.getFilterDate()

        return (
            <div className="page">

                <div className="player-page-header">

                    <div className="player-page-header-title">
                        <h1>{t("player.title")}</h1>
                        <span><b>{fitlered.title}</b> {fitlered.text}</span>
                    </div>

                    <div className="player-page-header-filter">
                        {this._search()}
                        {this._filter()}
                        {this._report()}
                    </div>

                </div>

                {/* Draw Content */}
                {this._content()}

                {/* Draw Statistics Modal */}
                {this._statistics()}

                {/* Draw Filter Modal */}
                <Filter apply={({ selected, start, end, operators }) => this.setState({ selected, start, end, operators }, () => this.load(true, 1))} ref={(ref) => this._filterModal = ref} />

            </div>
        )

    }


}


const mapStateToProps = (state) => {
    return {
        operators: state.operators,
        language: state.language,
    }
}

export default connect(mapStateToProps)(withRouter(Players))
